document.addEventListener('DOMContentLoaded', () => {

    // card listeners
    document.querySelectorAll('.collectionItemV2SwatchesSelectItem')?.forEach(item => {
        item.addEventListener('click', function () {
            if (this.classList.contains('active')) return;
            const parent = this.closest('.collectionItemV2');
            // update active status
            parent.querySelector('.collectionItemV2SwatchesSelectItem.active')?.classList.remove('active');
            this.classList.add('active');
            //update images
            parent.querySelector('.collectionItemV2VisualImage.active')?.classList.remove('active');
            parent.querySelector(`.collectionItemV2VisualImage[data-color="${this.dataset.color}"]`)?.classList.add('active');
        })
    })

    // compare button and hand off to compare page
    document.querySelectorAll('.collectionItemV2SwatchesCompare')?.forEach(compare => {
        compare.addEventListener('click', function () {
            localStorage.setItem("compare_id", this.dataset.id);
            window.location.href = '/pages/compare-safes'
        })
    })
})


